import env from "./env";

export const getQueryParam = queryParamName => {
  const href = new URL(window.location.href);
  const origin = href.searchParams.get(queryParamName);
  return origin || env.envURL;
}

export const getOriginParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("origin")) {
    let url = "";
    const entries = urlParams.entries();
    let i = 0;
    for (let param of entries) {
      const paramKey = param[0];
      const paramValue = param[1];
      const paramName = i !== 0 ? `&${paramKey}=` : "";
      url += paramName + paramValue;
      i++;
    }
    return url;
  }
  return env.envURL;
};

export const checkAuth = cb =>
  sendRequest(`${env.login}/verify-cookie`, "GET", cb);

export const getUserData = () =>
  sendRequest(`${env.user}/self`, "GET", res => res);

export const generateCookie = (username, password) => {
  const auth = window.btoa(username + ":" + password);
  const origin = getOriginParam();

  return sendRequest(`${env.login}/generate-cookie`, "POST", res => res, {
    Authorization: "Basic " + auth,
    "Redirect-Url": origin
  });
};

export const sendRequest = (
  path,
  method = "GET",
  cb = () => {},
  headers = {}
) => {
  const defaultHeaders = {
    "FFF-Auth": "V1.1",
    Origin: env.originURL,
    "Content-Type": "application/json; charset=utf-8"
  };
  return fetch(path, {
    credentials: "include",
    headers: { ...defaultHeaders, ...headers },
    data: {
      activatedOn: true
    },
    redirect: "manual",
    mode: "cors",
    method
  })
    .then(response => cb(response))
    .catch(err => {
      console.error("Fetch Failed: ", err);
      return err;
    });
};

export default sendRequest;
